<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <SelectCustom v-model="inputs.status" :is_view="is_view" :list="cd_options_status" label="Status" :required="true"/>
                        <SelectCustom v-model="inputs.fiscal_year" :is_view="is_view" :list="cd_options_fiscalYear" label="Fiscal Year" :required="true" />
                        <SelectCustom v-model="inputs.load_type" :is_view="is_view" :list="cd_options_loadType" label="Load Type" :required="true" />
                        <SelectHttp v-model="inputs.product_type" :is_view="is_view" label="Product Type" :required="true" url="/product_type/serverside/selectable-name" listValueField="name"/> 
                        <SelectHttp v-model="inputs.salesCoord" :is_view="is_view" label="Sales Coordinator" :required="true" url="/users/serverside/salesCoord/selectable-name" listValueField="full_name"/>
                        <SelectHttp v-model="inputs.logisticCoord" :is_view="is_view" label="Logistic Coordinator" :required="true" url="/users/serverside/logisticCoord/selectable-name" listValueField="full_name"/>
                        <SelectCustom v-model="inputs.shipment_type" :is_view="is_view" :list="cd_options_shipmentType" label="Shipment Type" :required="true" />
                        <InputNumber v-model="inputs.loads" :is_view="is_view" label="Loads" :required="true"/>
                        <InputNumber v-model="inputs.loads_completed" :is_view="is_view" label="Completed Loads" :required="true"/>
                        <InputNumber v-model="inputs.tem_celsius" :is_view="is_view" label="Temperature celsius" />
                        <SelectCustom v-model="inputs.load_method" :is_view="is_view" :list="cd_options_loadMethod" label="Load Method" :required="true" />
                        <SelectCustom v-if="permission_approve" v-model="inputs.approve_contract" :is_view="is_view" :list="cd_options_aproved" label="Approved & ready for Logistics"  />
                    </div>
                </div>

                <div class="row mt-4">
                    <CheckList v-model="inputs.checkbox" :list="list" :read="is_view"  />
                    <AdditionalInfo v-if="addMaster" v-model="inputs.additional_info" :addMaster="addMaster" :read="is_view" />  
                </div>

                <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="redirectToProductDetail">
                            {{ $t('continue') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import SelectCustom from '../components/SelectCustom.vue';
import SelectHttp from '../components/SelectHttp.vue';
import InputNumber from '../components/InputNumber.vue';
import CheckList from '../components/CheckList.vue';
import AdditionalInfo from '../components/AdditionalInfo.vue';
import { get_data_customTable, get_data_contract} from '../mixins/api.js';
import { listChek, validateForm} from '../mixins/functions.js';

export default {
    name: "contractDetail_form",
    mixins: [FormMixin],
    components : {
        SelectCustom,
        SelectHttp,
        InputNumber,
        CheckList,
        AdditionalInfo,
    },
    data() {
        return {
            permission_approve : false,
            addMaster : {},
            preloader: false,
            cd_options_status: [],
            cd_options_fiscalYear : [],
            cd_options_loadType: [],
            cd_options_shipmentType : [],
            cd_options_loadMethod : [],
            cd_options_aproved : [
                {id : 0, value : 'Not Approved'},
                {id : 2, value : 'Pending Approval'},
                {id : 1, value : 'Approved'},
            ],
            contractId : null, 
            list: [],
            inputs: {
                cd_contract_id : null,
                status : null,
                fiscal_year: null,
                load_type : null,
                product_type : { id: null},
                salesCoord : { id : null },
                logisticCoord : { id : null},
                shipment_type : null,
                loads : null,
                loads_completed : 0,
                tem_celsius : null,
                load_method : null,
                approve_contract : null,
                checkbox: [],
                additional_info : null,
                from_costing : [],
            },
        }  
    },
    computed: {
        is_view() {
            const is_view = localStorage.getItem('process_view_contract');
            if(is_view) return true;
            return false;
        },
    },

    created() {
        this.list = listChek(); // Llamar la función después de la inicialización del componente
    },

    methods: {
        async loadContractDetails(id) {
            if (id) {
                const respuesta = await get_data_contract(id);
                if (respuesta) {
                    localStorage.setItem('DataContractMaster', JSON.stringify(respuesta[0]));
                    this.addMaster = JSON.parse(localStorage.getItem('DataContractMaster'));
                    localStorage.setItem('DataContractDetail', JSON.stringify(respuesta[1])); 
                }
            }
        },

        async loadData(){
            this.preloader = true;
            this.isLoading = true;
            await Promise.all([
                this.fetchData('status'),
                this.fetchData('fiscal_year'),
                this.fetchData('load_type'),
                this.fetchData('shipment_type'),
                this.fetchData('load_method'),
            ]);
            const savedInputs = localStorage.getItem('DataContractDetail') 
                                ? JSON.parse(localStorage.getItem('DataContractDetail')) 
                                : null;
            if (savedInputs) {    
                await this.set_inputs(savedInputs);
            }
            this.validateRoles();
            this.isLoading = false;
            this.preloader = false;
        },

        async set_inputs(savedInputs){
            Object.keys(savedInputs).forEach(value => {
                this.inputs[value] = savedInputs[value];
            })
        },

        async fetchData(customTable) {
            const data = await get_data_customTable(customTable);
            if (customTable == 'status') this.cd_options_status = data; 
            else if (customTable == 'fiscal_year') this.cd_options_fiscalYear = data; 
            else if (customTable == 'load_type') this.cd_options_loadType = data;
            else if (customTable == 'shipment_type') this.cd_options_shipmentType = data;
            else if (customTable == 'load_method') this.cd_options_loadMethod = data;
        },

        validateRoles(){
            roles.forEach(rol => {
                const { id, name } = rol;
                if (id === 1 && name === 'App Admin') {
                    this.permission_approve = true;
                }
                if (id === 10 && name === 'President') {
                    this.permission_approve = true;
                }
                if (id === 7 && name === 'Accounting Coordinator') {
                    this.permission_approve = true;
                }
            });
        },
    
        redirectToProductDetail() {
            const validations = {
                status: 'Status required',
                fiscal_year: 'Fiscal year required',
                load_type: 'Load type required',
                product_type: 'Product type required',
                salesCoord : 'Sales Coordinator required',
                logisticCoord : 'Logistc Coordinator required',
                shipment_type : 'Shipment type required',
                loads : 'Load required',
                load_method : 'Load Method is required',
            }
            if (!validateForm(this.inputs, validations, this.$toastr)) {
                return;
            }
            this.redirected = true;
            this.$router.push({
                name: 'products',
                query: { 'tab': 'products' },
                params: { id: this.contractId }
            });
        },
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){
                if(this.isLoading) return; 
                localStorage.setItem('DataContractDetail', JSON.stringify(newVal));
            }
        }
    },

    async mounted() {
        this.addMaster = JSON.parse(localStorage.getItem('DataContractMaster')); 
        this.contractId = this.$route.params.id;
        if (this.contractId) {
            await this.loadContractDetails(this.contractId);
        }
        this.loadData();
    },
}
</script>
